<template>
	<component class="tt638" :is="tag">
		<slot></slot>
	</component>
</template>

<script>
export default {
	name: "j-text",
	props: {
		tag: {
			type: String,
			default: "p",
		},
	},
}
</script>

<style scoped>
.tt638 {
	display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/JText/index.vue